
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vefverslun/reiknivel",
      function () {
        return require("private-next-pages/vefverslun/reiknivel/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/vefverslun/reiknivel"])
      });
    }
  